import React, { useState, useEffect } from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, Grid, 
  IconButton, CircularProgress, Typography, Switch
} from '@mui/material';
import axios from 'axios';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useNotification } from "../../components/NotificationContext";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const showNotification = useNotification();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
  
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/users`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        setUsers(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Kullanıcılar getirilirken hata:', err);
        setError(err.response?.data?.message || err.message);
        setLoading(false);
        
        // 401 Unauthorized hatası durumunda login sayfasına yönlendir
        if (err.response?.status === 401) {
          localStorage.removeItem('token');
          // navigate('/login');
        }
      }
    };
    
    fetchUsers();
  }, []);

  const handleToggleRole = async (userId, currentRole) => {
    try {
      const token = localStorage.getItem('token');
      const newRole = currentRole === 'admin' ? 'user' : 'admin';
      
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/users/${userId}/admin`,
        { role: newRole },
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      // Kullanıcı listesini güncelle
      setUsers(users.map(user => 
        user.id === userId ? { ...user, role: newRole } : user
      ));
      showNotification('Rol Değişikliği Başarılı!', 'success');
    } catch (err) {
      console.error('Rol değiştirilirken hata:', err);
      showNotification('Rol Değişikliği Başarısız!', 'error');
    }
  };
  const handleBackClick = () => {
    navigate(-1);
  };
  const handleToggleSuspend = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
      
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/users/${userId}/suspend`,
        { status: newStatus },
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      // Kullanıcı listesini güncelle
      setUsers(users.map(user => 
        user.id === userId ? { ...user, status: newStatus } : user
      ));
      showNotification('Hesap durumu başarıyla güncellendi!', 'success');
    } catch (err) {
      console.error('Hesap durumu güncellenirken hata:', err);
      showNotification('Hesap durumu güncellenirken hata!', 'error');
    }
  };
  const fetchStatus = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/status/admin`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setStatus(response.data.durum);
      setLoading(false);
    } catch (err) {
      console.error('Durum verisi alınamadı:', err);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const handleToggle = async () => {
    const confirmChange = window.confirm('Sipariş Durumunu değiştirmek istediğinize emin misiniz?');
  
    if (!confirmChange) {
      return; // Kullanıcı "Hayır" dediyse, işlemi durdur
    }
  
    try {
      const token = localStorage.getItem('token');
    
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/users/status/toggle`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
    
      setStatus(response.data.durum); // Durum güncellendikten sonra state'i güncelle
      showNotification('Sipariş durumu başarıyla güncellendi!', 'success');
    } catch (err) {
      console.error('Durum değiştirilemedi:', err);
      showNotification('Sipariş durumu güncellenirken hata!', 'error');
    }
  };
  

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center" style={{ marginTop: '2rem' }}>
        Kullanıcılar yüklenirken hata: {error}
      </Typography>
    );
  }

  return (
    <Grid container justifyContent="center" alignItems="center" >
      <Grid size={{ xs: 12, sm: 11,md:11 }}>
        <Paper elevation={5} style={{ padding: '30px', borderRadius: '15px', backgroundColor: '#ffffff' }}>
        <IconButton onClick={handleBackClick} style={{ marginRight: '10px' }}>
        <ArrowBackIcon />
      </IconButton>
          <Typography variant="h4" gutterBottom align="center" style={{ fontWeight: 600, color: '#3f51b5' }}>
            Kullanıcılar
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Typography>Sipariş Alma: {status}</Typography>
      <Switch
        checked={status === 'aktif'}
        onChange={handleToggle}
        color="primary"
      />
    </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Ad Soyad</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Admin</TableCell>
              <TableCell>Telefon Numarası</TableCell>
              <TableCell align="right">Hesap Aktifliği</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                <Switch
  checked={user.role === 'admin'}
  onChange={() => handleToggleRole(user.id, user.role)}
  color="primary"
/>
                </TableCell>
                <TableCell>
                {user.phone}
                </TableCell>
                <TableCell align="right">
                <Switch
                        checked={user.status === 'active'} // Durumu kontrol et, aktifse switch açık
                        onChange={() => handleToggleSuspend(user.id, user.status)}
                        color="primary"
                      />
              </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </Paper>
      </Grid>
    </Grid>
  );
};

export default Users;